import { useEffect, useState } from 'react'
import { useReducedMotion } from './useReducedMotion'

export type PhoneStoryState = 'unplayed' | 'playing' | 'done'

/**
 * Each phone mockup plays its micro-animation once, the first time its step
 * becomes active, then settles on its final frame for good.
 */
export function usePhoneStory(isActive: boolean, durationMs = 2900): PhoneStoryState {
  const [state, setState] = useState<PhoneStoryState>('unplayed')
  const reducedMotion = useReducedMotion()

  useEffect(() => {
    if (!isActive || state !== 'unplayed') return

    if (reducedMotion) {
      setState('done')
      return
    }

    setState('playing')
    const timer = window.setTimeout(() => setState('done'), durationMs)
    return () => window.clearTimeout(timer)
  }, [isActive, state, reducedMotion, durationMs])

  return state
}
